var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-inline-flex" },
    [
      _c(
        "v-menu",
        {
          attrs: {
            "close-on-content-click": false,
            "offset-y": "",
            bottom: "",
            "max-width":
              _vm.$vuetify.breakpoint.name == "xs" ||
              _vm.$vuetify.breakpoint.name == "sm"
                ? "90%"
                : "400px",
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on: menuOn, attrs: menuAttrs }) {
                return [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({
                              on: tooltipOn,
                              attrs: tooltipAttrs,
                            }) {
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        attrs: {
                                          icon: "",
                                          small: "",
                                          disabled: _vm.disabled,
                                        },
                                        on: { click: _vm.loadNotifications },
                                      },
                                      "v-btn",
                                      { ...menuAttrs, ...tooltipAttrs },
                                      false
                                    ),
                                    { ...menuOn, ...tooltipOn }
                                  ),
                                  [
                                    _vm.notificationCount > 0
                                      ? _c(
                                          "v-badge",
                                          {
                                            attrs: {
                                              content: _vm.notificationCount,
                                              color: "orange",
                                              overlap: "",
                                              small: "",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  color: _vm.color,
                                                  small: "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "mdi-email-multiple-outline"
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              color: _vm.color,
                                              small: "",
                                            },
                                          },
                                          [_vm._v("mdi-email-multiple-outline")]
                                        ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [_c("span", [_vm._v("Histórico de Notificações")])]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.menu,
            callback: function ($$v) {
              _vm.menu = $$v
            },
            expression: "menu",
          },
        },
        [
          _c(
            "v-card",
            { attrs: { "min-width": "300" } },
            [
              _c(
                "v-card-title",
                { staticClass: "ma-0 pa-0" },
                [
                  _c(
                    "v-app-bar",
                    {
                      staticClass: "grey lighten-5 mb-0 elevation-1",
                      attrs: { dense: "" },
                    },
                    [
                      _c("v-toolbar-title", { staticClass: "subtitle-1" }, [
                        _vm._v(" Histórico de Notificações "),
                      ]),
                      _c("v-spacer"),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on, attrs }) {
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "mr-1",
                                          attrs: { icon: "", small: "" },
                                          nativeOn: {
                                            click: function ($event) {
                                              _vm.menu = false
                                            },
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "red lighten-2" } },
                                        [_vm._v("mdi-close")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [_c("span", [_vm._v("Fechar")])]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pa-0" },
                [
                  _vm.loading
                    ? _c("v-progress-linear", {
                        attrs: { indeterminate: "", color: "primary" },
                      })
                    : _vm._e(),
                  !_vm.loading && _vm.notifications.length > 0
                    ? _c(
                        "v-list",
                        { staticClass: "py-0", attrs: { dense: "" } },
                        _vm._l(
                          _vm.notifications,
                          function (notification, index) {
                            return _c(
                              "v-list-item",
                              {
                                key: notification.id || index,
                                staticClass: "px-4",
                              },
                              [
                                _c(
                                  "v-list-item-icon",
                                  { staticClass: "mr-3" },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: { small: "", color: "primary" },
                                      },
                                      [_vm._v("mdi-email-send-outline")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c(
                                      "v-list-item-title",
                                      { staticClass: "caption" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.formatDate(
                                                notification.sent_at
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    notification.user
                                      ? _c(
                                          "v-list-item-subtitle",
                                          { staticClass: "caption grey--text" },
                                          [
                                            _vm._v(
                                              " Por: " +
                                                _vm._s(notification.user.name) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        1
                      )
                    : _vm._e(),
                  !_vm.loading && _vm.loadError
                    ? _c(
                        "v-alert",
                        {
                          staticClass: "ma-3",
                          attrs: { type: "error", text: "", dense: "" },
                        },
                        [_vm._v(" Não foi possível carregar o histórico. ")]
                      )
                    : _vm._e(),
                  !_vm.loading &&
                  !_vm.loadError &&
                  _vm.notifications.length === 0
                    ? _c(
                        "v-alert",
                        {
                          staticClass: "ma-3",
                          attrs: { type: "info", text: "", dense: "" },
                        },
                        [_vm._v(" Nenhuma notificação enviada ainda. ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }